module.exports = __webpack_public_path__ + "static/img/s3.785358d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/s3.png
// module id = NW+2
// module chunks = 0